export const slideAnimationReverse = {
  in: {
    transform: "translate3d(50%, 0, 0)",
    opacity: 0,
    willChange: "transform, opacity",
    transition: {
      duration: 0.2,
      ease: [0.58, 0.015, 0.49, 0.99],
    },
  },
  animate: {
    transform: "translate3d(0, 0, 0)",
    opacity: 1,
    willChange: "transform, opacity",
    transition: {
      duration: 0.2,
      ease: [0.58, 0.015, 0.49, 0.99],
    },
  },
  out: {
    transform: "translate3d(50%, 0, 0)",
    opacity: 0,
    willChange: "transform, opacity",
    transition: {
      duration: 0.2,
      ease: [0.58, 0.015, 0.49, 0.99],
    },
  },
};

export const ANIM_PROFILE_DURATION = 0.22;
